import React, { Component } from "react";
import {Container } from "reactstrap";



class VoyAdvCard extends Component {
    render() { 
      const {  title, description, prix ,promotion} = this.props;
        return (
          <>
            <Container>
              <div className="voyadv__card d-flex justify-content-between">
                <div className="d-flex align-items-center">
                      <img
                        className="img-adv-hajj"
                        src="/imgs/announces/index.png"
                        alt=""
                      />
                      <div className="d-flex flex-column justify-content-center ml-3">
                          <a href={'/'}><h4 className="heberg-name-sr font-weight-bold"> {title} </h4></a>
                          <div className="agence-name-cstm mt-3">
                            <span className="agence-name">Nom de l'agence</span>
                            <h5 className="sc-fc-prms mt-2 text-wrap">{description}</h5>
                          </div>
                      </div>
                </div>
                <div className="d-flex flex-column align-items-end justify-content-center">
                {promotion &&
                  <div>
                  <span className="Promotion-badge px-3 py-1">Promotion</span>
                  </div>
                  }
                

                  <div className="mt-1">
                    <span className="prix-advances-search text-right py-0 ">
                      {prix} DZD
                    </span>
                  </div>
                  <div className={this.props.icons+ " "+ "d-flex" + " " +"mt-2 text-right"}>
                        <div className="message-vendeur-cstm text-center mr-2 py-1">
                            <img
                              src="/imgs/navebar/mail.svg"
                              alt=""
                              className="mail-crd m-1"
                            />
                          </div>
                          <div className="bascet-cstm text-center mr-2 py-1 px-2">
                            <img
                              src="/imgs/navebar/heart.svg"
                              alt=""
                              className="heart-crd"
                            />
                          </div>
                          <div className="shop-cstm p-1">
                            <img
                              src="/imgs/navebar/shoping.svg"
                              alt=""
                              className="shoping-crd"
                            />
                          </div>
                  </div>
                </div>
              </div>
              
           
              <hr style={{ width: "100%" }} className="mb-2 mt-2" />
            
            </Container>
          </>
        );
    }
}
 
export default VoyAdvCard;
